import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { useDispatch } from 'react-redux';
import './annuler-reservation.css'
import AnnulationPopup from "./annulation-popup";
import { setAlert } from "../actions/alert";
import { getPolitique } from "../../server/services/politique-service";
import Translator from "../translator";

function AnnulationReservationPage(props) {
  const dispatch = useDispatch();
  const language = props?.match?.params?.language || "fr";
  const t = Translator(language, "TXT_ANNULER_RESERVATION_PAGE");

  const [isOpen, setIsOpen] = useState(false);
  const [info, setInfo] = useState({ id: '', email: '' });
  const [idError, setIdError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [facture, setFacture] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);

  const validate = async () => {
    if (isSubmittingRef.current) {
      return;
    }

    let nextIdError = null;
    let nextEmailError = null;

    if (!info.id) {
      nextIdError = t.errorIdRequired;
    } else if (info.id > 100) {
      nextIdError = t.errorIdInvalid;
    }

    if (!info.email) {
      nextEmailError = t.errorEmailRequired;
    } else if (info.email > 100) {
      nextEmailError = t.errorEmailInvalid;
    }

    setIdError(nextIdError);
    setEmailError(nextEmailError);

    if (nextIdError || nextEmailError) {
      return;
    }

    isSubmittingRef.current = true;
    setIsSubmitting(true);
    try {
      const response = await getPolitique(info.id, info.email);

      if (!response || !response.length) {
        dispatch(setAlert(t.alertValidationFailed, 'danger'));
      } else {
        // dispatch(setAlert('Validation confirmée.', 'success')); // F904FAEE-BC90-EB11-AA57-D4AE526DD012 - mcbelanger54@videotron.ca
        setFacture(response);
        setIsOpen(true);
      }
    } catch {
      dispatch(setAlert(t.alertValidationFailed, 'danger'));
    } finally {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
    }
  }

  const handleFormSubmit = (e) => {
    e.preventDefault();
    validate();
  };

  function handleChange(target) {
    setInfo({ ...info, [target.name]: target.value });
  }

  return (
    <div id="profile-page">
      {isOpen && (
        <AnnulationPopup
          isOpen={isOpen}
          facture={facture}
          handleClose={() => setIsOpen(false)}
          language={language}
          noConfirmation={info.id}
        />
      )}
      <form className="annuler-reservation-page-form display-inline-block" onSubmit={handleFormSubmit} noValidate>
        <div>
          <div className="profile-label-wrapper">
            <span className="profile-span">{t.labelReservation}</span>
          </div>
          <div className="input-container">
            <input
              //   ref={input => this.usernameInput = input} 
              type="text"
              name="id"
              value={info.id ?? ''}
              onChange={(e) => handleChange(e.target)}
              //onChange={e => setId(e.target.value)}
              //   onChange={e => this.setState({ username: e.target.value })} 
              className="profile-input"
              disabled={isSubmitting}
            />
            {idError ? <span className="color-error profile-span">{idError}</span> : null}
          </div>
        </div>
        <div>
          <div className="profile-label-wrapper">
            <span className="profile-span">{t.labelEmail}</span>
          </div>
          <div className="input-container">
            <input
              type="text"
              name="email"
              value={info.email ?? ''}
              onChange={e => handleChange(e.target)}
              //   onChange={e => this.setState({ password: e.target.value })} 
              className="profile-input"
              disabled={isSubmitting}
            />
            {emailError ? <span className="color-error profile-span">{emailError}</span> : null}
          </div>

        </div>
        <div className="profile-div">
          <button
            type="submit"
            className="annuler-reservation-page-form-submit profile-div btn-login clickable"
            disabled={isSubmitting}
            aria-busy={isSubmitting}
          >
            <span className="profile-span annuler-reservation-page-form-submit-inner">
              {isSubmitting ? <span className="annuler-reservation-page-form-submit-spinner" aria-hidden="true" /> : null}
              {t.submit}
            </span>
          </button>
        </div>
      </form>
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  return {
  };
}

const dispatchProps = { setAlert };

export default connect(mapStateToProps, dispatchProps)(AnnulationReservationPage);